import { render } from "./DictManageView.vue?vue&type=template&id=17f962d3&scoped=true"
import script from "./DictManageView.vue?vue&type=script&lang=js"
export * from "./DictManageView.vue?vue&type=script&lang=js"

import "./DictManageView.vue?vue&type=style&index=0&id=17f962d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f962d3"]])

export default __exports__